import React from 'react';
import { MobileStepperCounter as EdsMobileStepperCounter } from '@hedtech/react-design-system/core/es/StepProgress';
const MobileStepperCounter = (props) => (React.createElement(EdsMobileStepperCounter, Object.assign({}, props)));
MobileStepperCounter.defaultProps = {
    activeStep: 0,
    steps: 1
};
export default MobileStepperCounter;
